import { useState, useEffect } from 'react';
import axios from 'axios';
import { RatingGetResult } from '../types';
import config from '../config/config.json';

const useRatingGet = (url: string): RatingGetResult => {
    const [ratingAvg, setRatingAvg] = useState<number>(0);
    const [ratingSum, setRatingSum] = useState<number>(0);
    const [ratingCount, setRatingCount] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        const getData = async (url: string): Promise<void> => {
            try {
                const { data } = await axios.post(config.ratingApiUrl.GET_RATING, { url });

                if (data?.ratingAvg && data?.ratingCount) {
                    const { ratingAvg, ratingCount } = data;
                    setRatingAvg(ratingAvg);
                    setRatingCount(ratingCount);
                    setRatingSum(ratingAvg * ratingCount);
                }
            } catch (error) {
                console.error(error);
            }

            setIsLoading(false);
        };

        getData(url);
    }, [url]);

    return {
        ratingAvg,
        ratingSum,
        ratingCount,
        isLoading
    };
};

export default useRatingGet;
